/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'

import { isEmpty } from 'lodash'

import { Filters } from 'components'

import { useFetch } from 'hooks'

import helpers from 'helpers'
import * as service from 'service'
import constants from 'constants/index'

const UserFilter = ({ filter }) => {
  const [companies, setCompanies] = useState([])
  const [isLoadingCompaniesInput, setIsLoadingCompaniesInput] = useState(false)
  const [companyInputValue, setCompanyInputValue] = useState('')
  const [isLoadingCompanies, setIsLoadingCompanies] = useState(false)
  const [selectedCompanyId, setSelectedCompanyId] = useState(
    filter.filters.companyId,
  )

  const [organizationInputValue, setOrganizationInputValue] = useState('')
  const [selectedOrganizationId, setSelectedOrganizationId] = useState(
    filter.filters.organizationId,
  )
  const [selectedOrganizationKind, setSelectedOrganizationKind] = useState(null)
  const [companyProfiles, setCompanyProfiles] = useState([])
  const [organizationProfiles, setOrganizationProfiles] = useState([])
  const [isLoadingProfiles, setIsLoadingProfiles] = useState(false)

  const {
    loadCompanies,
    mountCompanyParams,
    instructionsText: companyInstructionsText,
  } = helpers.companies.typeAndSearch
  const {
    mountOrganizationParams,
    instructionsText: organizationInstructionsText,
  } = helpers.organizations.typeAndSearch
  const { nameWithDocumentByArrayObject } = helpers.companies.nameWithDocument
  const { filters, drawerOpen } = filter

  const handleTypeCompaniesInput = (e) => {
    setCompanyInputValue(e.target.value)
  }

  const handleTypeOrganizationsInput = (e) => {
    setOrganizationInputValue(e.target.value)
  }

  const companiesOptionsValues = nameWithDocumentByArrayObject(
    isLoadingCompaniesInput ? [] : companies,
  )

  const companyProfilesOptionsValues = isLoadingProfiles ? [] : companyProfiles
  const organizationProfilesOptionsValues = () => {
    if (isLoadingProfiles) {
      return []
    }

    if (selectedOrganizationKind === constants.organizations.DPO_KIND) {
      return [
        ...constants.profile.DEFAULT_DPO_PROFILES_OPTIONS,
        ...organizationProfiles,
      ]
    }

    return [
      ...constants.profile.DEFAULT_OBSERVER_PROFILES_OPTIONS,
      ...organizationProfiles,
    ]
  }

  useEffect(() => {
    const getCompanies = setTimeout(() => {
      const hasCompanyValueToFetch =
        companyInputValue.length < 3 && isEmpty(filters?.companyId)

      if (hasCompanyValueToFetch || !drawerOpen) return

      loadCompanies(
        mountCompanyParams(companyInputValue, filters),
        setIsLoadingCompaniesInput,
        setCompanies,
      )
    }, 1000)

    return () => clearTimeout(getCompanies)
  }, [companyInputValue])

  const { response, isStillLoading: isOrganizationsStillLoading } = useFetch(
    service.backoffice.organizations.get,
    mountOrganizationParams({ organizationInputValue, filters }),
    [filters?.organizationId],
    organizationInputValue.length >= 3,
  )

  const organizations = response?.data?.organizations || []

  useEffect(() => {
    if (filters?.companyId) {
      loadCompanies(
        mountCompanyParams(companyInputValue, filters),
        setIsLoadingCompanies,
        setCompanies,
      )
    }
  }, [filters?.companyId])

  useEffect(() => {
    if (!drawerOpen && companyInputValue) setCompanyInputValue('')
    if (!drawerOpen && organizationInputValue) setOrganizationInputValue('')
  }, [drawerOpen])

  useEffect(() => {
    const getProfiles = async () => {
      try {
        setIsLoadingProfiles(true)

        const response = await service.backoffice.userProfiles.get({
          companyId: selectedCompanyId,
          perPage: 10000,
        })

        setCompanyProfiles(response?.data?.profiles || [])
      } finally {
        setIsLoadingProfiles(false)
      }
    }

    if (selectedCompanyId) {
      getProfiles()
    }
  }, [selectedCompanyId])

  useEffect(() => {
    const getProfiles = async () => {
      try {
        setIsLoadingProfiles(true)

        const response = await service.backoffice.userProfiles.get({
          organizationId: selectedOrganizationId,
          perPage: 10000,
        })

        setOrganizationProfiles(response?.data?.profiles || [])
      } finally {
        setIsLoadingProfiles(false)
      }
    }

    if (selectedOrganizationId) {
      getProfiles()
    }
  }, [selectedOrganizationId])

  useEffect(() => {
    if (filter.filters.companyId !== selectedCompanyId) {
      setSelectedCompanyId(filter.filters.companyId)
    }

    if (filter.filters.organizationId !== selectedOrganizationId) {
      setSelectedOrganizationId(filter.filters.organizationId)
    }
  }, [filter.filters.companyId, filter.filters.organizationId])

  const handleSelectOrganization = (organizationId) => {
    setOrganizationProfiles([])

    if (organizationId) {
      const fullSelectedOrganization = organizations.find(
        (org) => org.id === organizationId,
      )

      if (fullSelectedOrganization) {
        setSelectedOrganizationId(fullSelectedOrganization.id)
        setSelectedOrganizationKind(fullSelectedOrganization.kind)
      }
    } else {
      setSelectedOrganizationId(null)
      setSelectedOrganizationKind(null)
    }
  }

  return (
    <Filters filter={filter} isLoading={isLoadingCompanies}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Nome" name="name" />
      <input textfieldinput="true" label="E-mail" name="email" />
      <select
        autocompleteselectinput="true"
        label="Empresa"
        name="companyId"
        loading={isLoadingCompaniesInput}
        onChange={(companyId) => setSelectedCompanyId(companyId)}
        onChangeTypeSearch={handleTypeCompaniesInput}
        optionvalues={companiesOptionsValues}
        noOptionsText={companyInstructionsText(companyInputValue)}
      />
      {selectedCompanyId && (
        <select
          autocompleteselectinput="true"
          label="Perfil da Empresa"
          name="userCompanyProfileId"
          optionvalues={companyProfilesOptionsValues}
          loading={isLoadingProfiles}
          noOptionsText="Sem opções"
        />
      )}
      <select
        autocompleteselectinput="true"
        label="Grupo Advisor"
        name="organizationId"
        loading={isOrganizationsStillLoading}
        onChange={(organizationId) => handleSelectOrganization(organizationId)}
        onChangeTypeSearch={handleTypeOrganizationsInput}
        optionvalues={organizations}
        noOptionsText={organizationInstructionsText({ organizationInputValue })}
      />
      {selectedOrganizationId && (
        <select
          autocompleteselectinput="true"
          label="Perfil do Grupo Advisor"
          name="organizationUserProfileId"
          optionvalues={organizationProfilesOptionsValues()}
          loading={isLoadingProfiles}
          noOptionsText="Sem opções"
        />
      )}
    </Filters>
  )
}

export default UserFilter
